<template>
  <div class="content work_flow_wrap">
    <!-- 筛选区（SearchBar 组件，样式基准 productInformation） -->
    <search-bar
      v-model="query"
      :conditions="conditions"
      @search="search"
      @reset="reset"
      @height-change="recalcLayout"
    >
      <template #labelTypeGuid>
        <el-cascader
          size="mini"
          v-model="queryLabelTypePath"
          :options="labelTypeTree"
          :props="{ value: 'guid', label: 'dicName', children: 'childList', checkStrictly: true }"
          placeholder="请选择"
          clearable
          class="ipt-sty"
          @change="onQueryLabelType"
        ></el-cascader>
      </template>
    </search-bar>
    <div class="button-area">
      <el-button size="mini" type="info" @click="openDialog()">新建</el-button>
    </div>

    <!-- 列表 -->
    <div class="back-color-fff content-main-box" ref="tableBox" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (query.pageIndex - 1) * query.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
      <el-table-column prop="modelName" label="模型名称" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="labelTypeName" label="适用标注类型" width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="dataModalName" label="数据模态" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="开启状态" width="90">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enableState === 'Y' ? 'success' : 'info'" size="small">
            {{ scope.row.enableState === "Y" ? "启用" : "停用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="backendUrl" label="后端url" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="认证方式" width="100">
        <template slot-scope="scope">{{ scope.row.authType === "BASIC" ? "基本认证" : "无认证" }}</template>
      </el-table-column>
      <el-table-column prop="createUserName" label="创建人" width="90"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="updateUserName" label="更新人" width="90">
        <template slot-scope="scope">{{ scope.row.updateUserName || "-" }}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.updateUserName ? formatTime(scope.row.updateTime) : "-" }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="text" @click="toggleState(scope.row)">
            {{ scope.row.enableState === "Y" ? "停用" : "启用" }}
          </el-button>
          <el-button type="text" class="danger" @click="onDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      </el-table>

      <el-pagination
        ref="pager"
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="pageChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="query.pageIndex"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新建/编辑弹框 -->
    <el-dialog :title="form.guid ? '编辑预标注模型' : '新建预标注模型'" :visible.sync="dialogVisible" width="560px">
      <el-form :model="form" label-width="130px">
        <el-form-item label="模型名称:" required>
          <el-input v-model="form.modelName" maxlength="20" placeholder="请输入模型名称，最多20个字"></el-input>
        </el-form-item>
        <el-form-item label="适用标注类型:" required>
          <el-cascader
            v-model="formLabelTypePath"
            :options="labelTypeTree"
            :props="{ value: 'guid', label: 'dicName', children: 'childList', checkStrictly: true }"
            placeholder="请单选，多层级任意层级都可以选"
            class="w100f"
            @change="onFormLabelType"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="数据模态:" required>
          <el-select v-model="form.dataModalGuid" placeholder="请选择" class="w100f" @change="onModalChange">
            <el-option v-for="item in modalOptions" :key="item.guid" :label="item.dicName" :value="item.guid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="后端URL:" required>
          <el-input v-model="form.backendUrl" maxlength="50" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="启用状态:">
          <el-switch v-model="form.enableState" active-value="Y" inactive-value="N"></el-switch>
        </el-form-item>
        <el-form-item label="认证方式:" required>
          <el-select v-model="form.authType" @change="onAuthTypeChange">
            <el-option label="无认证" value="NONE"></el-option>
            <el-option label="基本认证" value="BASIC"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.authType === 'BASIC'">
          <el-form-item label="基本认证用户:" required>
            <el-input v-model="form.authUser" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="基本认证密码:" required>
            <el-input
              v-model="form.authPassword"
              type="password"
              show-password
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="额外参数:">
          <el-input
            v-model="form.extraParams"
            type="textarea"
            :rows="3"
            maxlength="200"
            placeholder="模型连接期间传递的任何额外参数（非必填）"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="onVerifyAndSave">验证并保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar";

export default {
  name: "prelabelModelConf",
  components: { SearchBar },
  data() {
    return {
      // 引导估值：el-table 以 0 起步再在 mounted 里改值会丢高度更新（表格压成 0），先给非 0 初值，挂载后 recalcLayout 实测校正
      tableHeight: window.innerHeight - 320,
      contentMainHeight: window.innerHeight - 250,
      conditions: [
        { key: "modelName", label: "模型名称", type: "input" },
        { key: "labelTypeGuid", label: "适用标注类型", type: "slot" },
        { key: "dataModalGuid", label: "数据模态", type: "select", options: [] },
        {
          key: "enableState",
          label: "开启状态",
          type: "select",
          more: true,
          options: [
            { label: "启用", value: "Y" },
            { label: "停用", value: "N" },
          ],
        },
      ],
      labelTypeTree: [],
      modalOptions: [],
      queryLabelTypePath: [],
      formLabelTypePath: [],
      query: {
        modelName: "",
        labelTypeGuid: "",
        dataModalGuid: "",
        enableState: "",
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      tableLoading: false,
      dialogVisible: false,
      submitting: false,
      form: {},
    };
  },
  mounted() {
    this.recalcLayout();
    window.addEventListener("resize", this.recalcLayout);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcLayout);
  },
  created() {
    this.getLabelTypeTree();
    this.getModalOptions();
    this.search();
  },
  methods: {
    // 高度锚点实测：以内容盒顶部为锚，免去 header/条件行等魔法数；底部留 8px；取整避免小数像素
    recalcLayout() {
      if (!this.$refs.tableBox) return;
      const top = this.$refs.tableBox.getBoundingClientRect().top;
      this.contentMainHeight = Math.floor(window.innerHeight - top - 8);
      this.tableHeight = Math.floor(this.contentMainHeight - this.$refs.pager.$el.offsetHeight - 2);
      // 兜底：el-table 的 height watcher 有首帧丢更新场景（prop 已变而内部 layout 不动），nextTick 强制重设一次，已一致时幂等
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.layout.setHeight(this.tableHeight);
      });
    },
    formatTime(time) {
      return time ? this.$moment(time).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    // 标注类型字典树（两级，任意层级可选）
    getLabelTypeTree() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=标注类型`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.labelTypeTree = res.data.data || [];
          }
        });
    },
    onQueryLabelType(path) {
      this.query.labelTypeGuid = path && path.length ? path[path.length - 1] : "";
    },
    onFormLabelType(path) {
      this.form.labelTypeGuid = path && path.length ? path[path.length - 1] : "";
      // 冗余名称
      let name = "";
      let nodes = this.labelTypeTree;
      for (const guid of path || []) {
        const node = (nodes || []).find((item) => item.guid === guid);
        if (!node) break;
        name = node.dicName;
        nodes = node.childList;
      }
      this.form.labelTypeName = name;
    },
    // 数据模态字典（与数据集/标签模板同源「数据模态」字典；三方模态一致性用）
    getModalOptions() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=数据模态`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            const tree = res.data.data || [];
            // 返回可能是 [数据模态父项 childList] 或直接子项列表，兼容两种结构（labelDatasetManage 同款）
            const parent = tree.find((item) => item.childList && item.childList.length);
            this.modalOptions = parent && parent.dicName === "数据模态" ? parent.childList : tree;
            const cond = this.conditions.find((item) => item.key === "dataModalGuid");
            if (cond) {
              cond.options = this.modalOptions.map((item) => ({ label: item.dicName, value: item.guid }));
            }
          }
        });
    },
    onModalChange(guid) {
      const hit = this.modalOptions.find((item) => item.guid === guid);
      this.form.dataModalName = hit ? hit.dicName : "";
    },
    onAuthTypeChange(val) {
      if (val !== "BASIC") {
        this.form.authUser = "";
        this.form.authPassword = "";
      }
    },
    search() {
      this.tableLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/prelabel-model/page-list`, this.query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tableData = res.data.data.records || [];
            // 分页总数字段为 totalRows（FOUR-2965：读 total 恒 undefined 兜底 0 致“共 0 条”）
            this.total = res.data.data.totalRows || res.data.data.total || 0;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.query = {
        modelName: "",
        labelTypeGuid: "",
        dataModalGuid: "",
        enableState: "",
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
      };
      this.queryLabelTypePath = [];
      this.search();
    },
    pageChange(page) {
      this.query.pageIndex = page;
      this.search();
    },
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.search();
    },
    openDialog(row) {
      if (row && row.guid) {
        this.form = { ...row };
        this.formLabelTypePath = this.findLabelTypePath(row.labelTypeGuid);
        // 列表接口密码脱敏，编辑回显走 edit-detail 取完整数据（含密码）
        this.api
          .get(`/${serverConfig.msSalesPerformService}/prelabel-model/edit-detail?guid=${row.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
              const detail = res.data.data;
              this.form = { ...this.form, ...detail, authPassword: detail.authPassword || "" };
              this.formLabelTypePath = this.findLabelTypePath(detail.labelTypeGuid);
            }
          });
      } else {
        this.form = {
          guid: "",
          tenantGuid: localStorage.guid,
          modelName: "",
          labelTypeGuid: "",
          labelTypeName: "",
          dataModalGuid: "",
          dataModalName: "",
          backendUrl: "",
          authType: "NONE",
          authUser: "",
          authPassword: "",
          extraParams: "",
          enableState: "Y",
        };
        this.formLabelTypePath = [];
      }
      this.dialogVisible = true;
    },
    findLabelTypePath(guid) {
      if (!guid) return [];
      // 递归查找，层级加深也能回显
      const walk = (nodes, target, trail) => {
        for (const node of nodes || []) {
          const next = [...trail, node.guid];
          if (node.guid === target) return next;
          const hit = walk(node.childList, target, next);
          if (hit) return hit;
        }
        return null;
      };
      return walk(this.labelTypeTree, guid, []) || [];
    },
    checkForm() {
      if (!this.form.modelName) return "请输入模型名称";
      if (!this.form.labelTypeGuid) return "请选择适用标注类型";
      if (!this.form.dataModalGuid) return "请选择数据模态";
      if (!this.form.backendUrl) return "请输入后端URL";
      // 缺协议头会在后端构造 URI 时秒败，被"服务器无法访问"的网络文案掩盖，须前置拦截
      if (!/^https?:\/\//.test(this.form.backendUrl.trim())) return "后端URL须以 http:// 或 https:// 开头";
      if (this.form.authType === "BASIC") {
        if (!this.form.authUser) return "基本认证用户必填";
        if (!this.form.authPassword) return "基本认证密码必填";
      }
      return "";
    },
    onVerifyAndSave() {
      const errMsg = this.checkForm();
      if (errMsg) {
        this.$message.error(errMsg);
        return;
      }
      this.submitting = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/prelabel-model/verify-and-save`, this.form)
        .then((res) => {
          this.submitting = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.search();
          } else {
            // 连通性验证失败等提示原样展示（模型连接失败请重新调整信息）
            this.$message.error(res.data.msg || "保存失败");
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    toggleState(row) {
      const target = row.enableState === "Y" ? "N" : "Y";
      const text = target === "N" ? "停用" : "启用";
      this.$confirm(`确定${text}该模型吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/prelabel-model/update-state?guid=${row.guid}&enableState=${target}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success(text + "成功");
              this.search();
            } else {
              this.$message.error(res.data.msg || text + "失败");
            }
          });
      });
    },
    onDelete(row) {
      this.$confirm("确定删除该模型吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/prelabel-model/delete?guid=${row.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          });
      });
    },
  },
};
</script>

<style scoped>
.danger {
  color: #f56c6c;
}
.w100f {
  width: 100%;
}
/* 操作列竖线分隔（对齐 certAuditManage 定的标准）：紧凑间距、竖线继承 teal；限表格内防误伤弹框按钮 */
.content /deep/ .el-table .el-button + .el-button {
  margin-left: 4px;
}
.content /deep/ .el-table .el-button + .el-button::before {
  content: "|";
  display: inline-block;
  margin-right: 4px;
  color: #4fa1a4 !important;
}
/* 弹窗表单控件左对齐（覆盖全局 #app 居中对 el-switch/el-select 等行内块的影响） */
.el-form {
  text-align: left;
}
</style>
